import {
	cloneDeep
} from 'lodash';

import moment from 'moment';

import Http from '@/support/http';

export default {
	getHomeworkBySchoolClass(context, payload) {

		if (payload && payload.userId && payload.schoolClassId && payload.agendaDate) {

			const {
				userId,
				agendaDate,
				schoolClassId
			} = payload;

			const route = `v2/homework/school-class/${ schoolClassId }/user/${ userId }?date=${ agendaDate }`;

			return Http.get(route).then((response) => {
				return response.data;
			});

		}

	},
	setHomeworkList(context, payload) {

		context.commit('SET_HOMEWORK_LIST', payload);

	},
	saveHomeworkBySchoolClass(context, payload) {

		if (payload) {

			const route = `v2/homework/user/${ context.getters.getLoggedUser.id }`;
			const payloadClone = cloneDeep(payload);

			payloadClone.themes.map((value) => {

				if (value.dueDate) {
					value.dueDate = moment(value.dueDate).format('YYYY-MM-DD');
				}

				return value;

			});

			return Http.post(route, payloadClone).then((response) => {

				response.data.themes.map((value) => {

					if (value.dueDate) {
						value.dueDate = moment(value.dueDate).toISOString();
					}

					return value;

				});

				context.commit('SET_HOMEWORK_LIST', response.data);

				return response;

			});

		}

	},
	publishHomeworkBySchoolClass(context, payload) {

		if (payload) {

			const route = `v2/homework/${ payload.homeworkId }/theme/${ payload.themeId }/user/${ payload.user }`;

			return Http.post(route).then((response) => {

				response.data.themes.map((value) => {

					if (value.dueDate) {
						value.dueDate = moment(value.dueDate).toISOString();
					}

					return value;

				});
				context.commit('SET_HOMEWORK_LIST', response.data);

				return response;

			});
		}

	},
	publishAllHomeworkBySchoolClass(context, payload) {

		if (payload) {
			return Http.post(`v2/homework/${ payload.id }/user/${ payload.userId }`);
		}

	},
	putHomeworkItemByKey(context, payload) {

		if (payload) {
			context.commit('PUT_HOMEWORK_ITEM_BY_KEY', cloneDeep(payload));
		}

	},

	putExclusiveHomeworkItemByKey(context, payload) {
		if (payload) {
			context.commit('PUT_EXCLUSIVE_HOMEWORK', cloneDeep(payload));
		}

	}
};



// WEBPACK FOOTER //
// ./sources/domains/homework/actions.js